import script from "./LgpdLegitimateInterestConsentConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./LgpdLegitimateInterestConsentConfig.vue?vue&type=script&setup=true&lang=js"

import "./LgpdLegitimateInterestConsentConfig.vue?vue&type=style&index=0&id=114ed910&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-114ed910"]])

export default __exports__